/*
 * @Descripttion: websocket连接
 * @Author: chenjinsheng
 * @Date: 2021-09-08 09:02:48
 * @LastEditors: chenjinsheng
 * @LastEditTime: 2021-09-08 09:38:59
 */
let websocket = null;
let interval = null;
/**
 * 创建连接
 * url：websocket 请求地址
 * callback:回调方法
 */
export function openWebSocket(url, callback) {
    //判断当前浏览器是否支持WebSocket
    if ("WebSocket" in window) {
        //建立连接
        websocket = new WebSocket(url);
    } else {
        alert("当前浏览器 Not support websocket");
    }
    // 连接发生错误的回调方法
    websocket.onerror = function() {
        callback("err");
    };
    //连接成功建立的回调方法
    websocket.onopen = function() {
        openInterval();
        callback("success");
    };
    // 接收到消息的回调方法
    websocket.onmessage = function(event) {
        let data = event.data;
        if (typeof data === "string") {
            data = JSON.parse(data);
        }
        callback("message", data);
    };
    // 连接关闭的回调方法
    websocket.onclose = function() {
        callback("close");
    };
    // 监听窗口关闭事件，当窗口关闭时，主动去关闭websocket连接，防止连接还没断开就关闭窗口，server端会抛异常。
    window.onbeforeunload = function() {
        closeWebSocket();
    };
}

// 30秒 心跳监听
function openInterval() {
    if (websocket) {
        interval = setInterval(() => {
            send({ event: "heartbeat", body: new Date().getTime() });
        }, 30000);
    }
}

// 关闭心跳监听
export function closeInterval() {
    if (!interval) {
        return;
    }
    setTimeout(() => {
        closeInterval(interval);
        interval = null;
    }, 1000);
}

//关闭WebSocket连接
export function closeWebSocket() {
    websocket.close();
}

/**
 * 发送消息
 * message :消息内容
 */
export function send(message) {
    if (websocket) {
        if (typeof message !== "string") {
            message = JSON.stringify(message);
        }
        websocket.send(message);
    }
}

// 创建连接
// let url = "ws://192.168.1.77:7100/mc/websocket"
// openWebSocket(url)
